import {atom} from "recoil";

export const latestBlockState = atom<{height:number,hash:string}>({
    key: 'latest-block',
    default: {
        height:-1,
        hash:'',
    },
});


